import { render, staticRenderFns } from "./LaborProtectionChecklistsTable.vue?vue&type=template&id=1271e20d&"
import script from "./LaborProtectionChecklistsTable.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionChecklistsTable.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionChecklistsTable.vue?vue&type=style&index=0&id=1271e20d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports